//= ===========================================================##
// jQuery
// il faut mettre les window. pour que $ soit disponbile
// pour @reils/ujs avec les link :remote => true
//= ===========================================================##
import 'chartkick/highcharts'

//= ===========================================================##
// Certaines librairies ne sont pas exposées dans son fichier js...
// il faut l'appeler explicitement
//= ===========================================================##
import autosize from 'autosize'
require('jquery')
window.jQuery = $
window.$ = $

require('@rails/ujs').start()
require('turbolinks').start()

//= ===========================================================##
// libs
//= ===========================================================##
require('jquery-ui-dist/jquery-ui')
window.bootstrap = require('bootstrap')
require('HoldOn.js/src/js/HoldOn.min.js')
require('autosize')
require('select2/dist/js/select2.full')
require('select2/dist/css/select2.css')
require('select2-bootstrap4-theme/dist/select2-bootstrap4.css')
require('moment')
require('bootstrap4-datetimepicker/build/js/bootstrap-datetimepicker')
require('bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.min')
require('pickadate/lib/compressed/picker.js')
require('pickadate/lib/compressed/picker.time.js')
require('pickadate/lib/themes/classic.css')
require('pickadate/lib/themes/classic.time.css')

//= ===========================================================##
// Pour importer le fichier index.ds du dossier sweetalert
// Dans lequel on a overwrite le comportement du data
// confirm de rails
//= ===========================================================##
import('sweetalert')

import('styles/application.css')

//= ===========================================================##
// Setup Select2 sur les selects
//= ===========================================================##
window.setupSelect2 = () => {
  const optionFormat = function (item) {
    if (!item.id) {
      return item.text
    }

    const span = document.createElement('span')
    const imgUrl = item.element.getAttribute('data-picture-url')
    let template = ''

    if (imgUrl) {
      template += '<img src="' + imgUrl + '" class="rounded-circle h-20px me-2" alt="image"/>'
    }
    template += item.text

    span.innerHTML = template

    return $(span)
  }

  $('.modal .select2, .modal select.form-control:not(.no-select2)').each(function () {
    const closestModal = $(this).closest('.modal')
    const isMultiple = $(this).attr('multiple') === 'multiple'
    const placeholder = $(this).attr('data-placeholder')

    $(this).select2({
      theme: 'bootstrap5',
      minimumResultsForSearch: 10,
      dropdownParent: closestModal || null,
      width: '100%',
      closeOnSelect: !isMultiple,
      language: $('html').attr('lang'),
      templateSelection: optionFormat,
      templateResult: optionFormat,
      placeholder: placeholder ? placeholder : null,
      selectionCssClass: ':all:'
    })
  })
}

//= ===========================================================##
// Création d'un systeme de flash messages pour JS
//= ===========================================================##
window.flash = (level, message) => {
  $('#flashMessageContainer').append(
    `<div class='alert flash-${level} animated bounceInRight'><a class='close' data-bs-dismiss='alert' href='#' aria-hidden='true'>×</a>${message}</div>`
  )
}

//= ===========================================================##
// Spinner
//= ===========================================================##
window.spin = (on_off) => {
  if (on_off) {
    HoldOn.open({
      theme: 'sk-rect',
      message: I18n.app.please_wait,
      textColor: 'white'
    })
  } else {
    if (typeof HoldOn !== 'undefined' && HoldOn !== null) {
      HoldOn.close()
    }
  }
}

window.validURL = (str) => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' +
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
      '(\\?[;&a-z\\d%_.~+=-]*)?' +
      '(\\#[-a-z\\d_]*)?$',
    'i'
  )
  return !!pattern.test(str)
}

//= ===========================================================##
// Delay
//= ===========================================================##
window.delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()

//= ===========================================================##
// Video Player : Events
//= ===========================================================##
window.setup_video_player = (video) => {
  // Add event listeners for video specific events
  $('#video').on('play', () =>
    $('#playpause').html('<i class="fas fa-lg fa-pause-circle"></i>')
  )
  $('#video').on('pause', () =>
    $('#playpause').html('<i class="fas fa-lg fa-play-circle"></i>')
  )

  // Add events for all buttons
  $('#playpause').on('click', function (e) {
    if (video.paused || video.ended) {
      video.play()
    } else {
      video.pause()
    }
  })

  $('#mute').on('click', function (e) {
    video.muted = !video.muted
    if (video.muted) {
      $('#mute').html('<i class="fas fa-lg fa-volume-slash float-right"></i>')
    } else {
      $('#mute').html('<i class="fas fa-lg fa-volume-up float-right"></i>')
    }
  })

  // As the video is playing, update the progress bar
  $('#video').on('timeupdate', function () {
    $('#progress').attr('max', video.duration)
    $('#progress').val(video.currentTime)
    $('#progress-bar')[0].style.width =
      Math.floor((video.currentTime / video.duration) * 100) + '%'
  })

  // React to the user clicking within the progress bar
  $('#progress').on('click', function (e) {
    let modal_offset
    const progress = $('#progress')[0]
    if ($('#myModalPlay > .modal-dialog')[0] !== undefined) {
      // if we're in a modal, we add this offset
      modal_offset = $('#myModalPlay > .modal-dialog')[0].offsetLeft
    } else {
      // if we're not in a modal, we're in a container (and we add 15, because ... because! (and it's the square root of 225))
      modal_offset = $('div.container')[0].offsetLeft + 15
    }

    const pos =
      (e.pageX -
        (progress.offsetLeft +
          progress.offsetParent.offsetLeft +
          progress.offsetParent.offsetParent.offsetLeft +
          modal_offset)) /
      progress.offsetWidth
    return (video.currentTime = pos * video.duration)
  })
}

//= ===========================================================##
// confirmation dialog
//= ===========================================================##
window.confirmationDialog = (settings) => {
  return new Promise((resolve, reject) => {
    let buttons = {}
    if (settings.buttons === 'yes/no') {
      buttons = {
        Non: {
          click: function () {
            $(this).dialog('close')
            return reject(false)
          },
          class: 'btn btn-white btn-sm',
          text: 'Non'
        },
        Oui: {
          click: function () {
            $(this).dialog('close')
            return resolve(true)
          },
          class: 'active btn btn-primary btn-sm ms-3',
          text: 'Oui'
        }
      }
    } else if (settings.buttons === 'confirm') {
      buttons = {
        Annuler: {
          click: function () {
            $(this).dialog('close')
            return reject(false)
          },
          class: 'btn btn-white btn-sm',
          text: 'Annuler'
        },
        Confirmer: {
          click: function () {
            $(this).dialog('close')
            return resolve(true)
          },
          class: 'btn btn-primary btn-sm ms-3',
          text: 'Confirmer'
        }
      }
    } else if (settings.buttons === 'ok') {
      buttons = {
        Compris: {
          click: function () {
            $(this).dialog('close')
            return resolve(true)
          },
          class: 'active btn btn-primary btn-sm',
          text: 'Compris'
        }
      }
    } else {
      buttons = {

        [settings.buttons.getAttribute('data-nobtn')]: {
          click: function () {
            $(this).dialog('close')
            return reject(false)
          },
          class: 'btn btn-white btn-sm',
          text: settings.buttons.getAttribute('data-nobtn')
        },
        [settings.buttons.getAttribute('data-yesbtn')]: {
          click: function () {
            spin(true)
            $(this).dialog('close')
            return resolve(true)
          },
          class: 'active btn btn-primary btn-sm ms-3',
          text: settings.buttons.getAttribute('data-yesbtn')
        }
      }
    }
    $('<div><strong>' + settings.title + '</strong><p>' + settings.message + '</p></div>').dialog({
      modal: true,
      appendTo: settings.appendTo,
      zIndex: 1052,
      autoOpen: true,
      width: '100%',
      resizable: false,
      show: {
        effect: 'fade',
        duration: 500
      },
      hide: {
        effect: 'fade',
        duration: 500
      }
    }).dialog('option', 'buttons', buttons)
  })
}

$(document).on('turbolinks:before-cache', function () {
  $('.select2, select.form-control:not(.no-select2)').select2('destroy')
})

document.addEventListener('turbolinks:load', function () {
  //= ===========================================================##
  // Init Same libs
  //= ===========================================================##
  $('.toast').toast('show')
  $('[data-bs-toggle="tooltip"]').tooltip({ track: true })

  $('body').popover({
    trigger: 'hover',
    sanitize: false,
    html: true,
    animation: true,
    selector: '[data-bs-toggle=popover]',
    container: 'body'
  })

  //= ===========================================================##
  // SELECT 2
  //= ===========================================================##
  $('.select2, select.form-control:not(.no-select2)').each(function () {
    const classes = $(this).attr('class')

    $(this).select2({
      minimumResultsForSearch: 12,
      language: $('html').attr('lang'),
      selectionCssClass: ':all:'
    })
  })

  $('.dropdown-stats-ele').select2({
    // theme: 'bootstrap4',
    minimumResultsForSearch: 12,
    language: $('html').attr('lang'),
    templateResult: addUserPic,
    templateSelection: addUserPic
  })

  $('.dropdown-stats-ele').on('change', function () {
    // get selected value data url
    const url = $(this).find(':selected').data('url')
    window.location.href = url
  })

  // Caption page
  $('.gmb-clickable').change(function () {
    if ($(this).prop('checked')) {
      $('.gmb-clickable-options select').val('learn_more')
      if ($('.gmb-clickable-options select').val() === 'learn_more') {
        $('.gmb-clickable-url').removeClass('d-none')
        $(this).parents('.flex-group')
      } else {
        $(this).parents('.flex-group')
      }
      $('.gmb-clickable-options').removeClass('d-none')
    } else {
      $('.gmb-clickable-options').addClass('d-none')
      $('.gmb-clickable-options').addClass('d-none')
      $('.gmb-clickable-url').addClass('d-none')
      $('.gmb-call-notice').addClass('d-none')
      $(this).parents('.flex-group')
    }
  })

  $(document).on('change', '#gmb_legend_action_type', function () {
    if ($(this).val() === 'learn_more') {
      $('.gmb-clickable-url').removeClass('d-none')
      $('.gmb-call-notice').addClass('d-none')
    } else {
      $('.gmb-clickable-url').addClass('d-none')
      $('.gmb-call-notice').removeClass('d-none')
    }
  })

  function addUserPic (opt) {
    if (!opt.id) {
      return opt.text
    }
    const optimage = $(opt.element).data('image')
    const optuserImage = $(opt.element).data('src')
    const url = $(opt.element).data('url')
    if (!optimage) {
      return opt.text
    } else {
      if (optuserImage == '' || optuserImage == null) {
        var $opt = $(
          `<div class="stats-page__selector__img"><div class="stats-page__selector__avatar"></div><span class="stats-page__selector__icon"><i class="${optimage}"></i></span> ${$(opt.element).text()}</div>`
        )
      } else {
        var $opt = $(
          `<div class="stats-page__selector__img"><div class="stats-page__selector__avatar" style="background-image:url();"></div><span class="stats-page__selector__icon"><i class="${optimage}"></i></span> ${$(opt.element).text()}</div>`
        )
      }
      return $opt
    }
  };
  $('#dropdownReviewAccount').on('change', function (e) {
    const dataURL = $(this).find(':selected').first().data('url')
    window.location.href = dataURL
  })

  $('.dropdown-review-ele').on('select2:select', function (e) {
    const data = e.params.data
    const dataURL = $(data.element).data('url')
    window.location.href = dataURL
  })
  //= ===========================================================##
  // Remove flash Notice
  //= ===========================================================##
  delay(() => $('.flash-notice').fadeOut(), 8000)

  //= ===========================================================##
  // Emoji Selector
  //= ===========================================================##
  $('.emoji-button').on('click', function () {
    const field_name = $(this).data('field')
    const fields = $(
      `input[name='${field_name}'], textarea[name='${field_name}']`
    )
    $(fields).val(`${$(fields).val()} ${$(this).html()}`)
  })

  //= ===========================================================##
  // Smooth Scroll
  //= ===========================================================##
  $('a[data-scroll][href*="#"]:not([href="#"])').click(function () {
    if (
      location.pathname.replace(/^\//, '') ===
        this.pathname.replace(/^\//, '') &&
      location.hostname === this.hostname
    ) {
      let target = $(this.hash)
      target = target.length ? target : $(`[name=${this.hash.slice(1)}]`)
      if (target.length) {
        $('html, body').animate({ scrollTop: target.offset().top - 48 }, 1000)
        return false
      }
    }
  })

  //= ===========================================================##
  // Init Autosize on all textarea + sur les collapse + tab
  // + modal de boostrap
  //= ===========================================================##
  autosize(document.querySelectorAll('textarea'))

  $('.collapse').on('shown.bs.collapse', function () {
    const textareas = $('textarea')
    autosize(textareas)
    autosize.update(textareas)
  })

  $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function () {
    const textareas = $('textarea')
    autosize(textareas)
    autosize.update(textareas)
  })

  $('.modal').on('shown.bs.modal', function () {
    const textareas = $('textarea')
    autosize(textareas)
    autosize.update(textareas)
  })

  //= ===========================================================##
  // Disable pinch mobile
  //= ===========================================================##
  document.documentElement.addEventListener(
    'touchstart',
    function (event) {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    },
    false
  )

  //= ===========================================================##
  // Date picker
  //= ===========================================================##
  const now = new Date()
  const today = now.setDate(now.getDate())
  $('.datepicker').datetimepicker({
    format: 'YYYY-MM-DD',
    locale: 'fr',
    icons: {
      time: 'fas fa-clock-o',
      date: 'fas fa-calendar',
      up: 'fas fa-chevron-up',
      down: 'fas fa-chevron-down',
      previous: 'fas fa-chevron-left',
      next: 'fas fa-chevron-right',
      today: 'fas fa-check',
      clear: 'fas fa-trash',
      close: 'fas fa-times'
    },
    minDate: today
  })

  //= ===========================================================##
  // Time picker
  //= ===========================================================##
  $('.pickatime').pickatime({
    format: 'HH:i',
    interval: 15
  })
})

// Robeen : Removed cause I don't like the fact that it triggers for every ajax call
// $(document).ajaxStart(function () {
//   spin(true)
// })

// $(document).ajaxStop(function () {
//   spin(false)
// })

require('./modals/upload-content-modal')
require('./modals/create-post-v2')
require('./modals/review-visual')
require('./00_all_pages')
require('./advance_settings')
require('./pages/property_contents') // bootstrap model is available only if we load here needs investigation
require('./imgly-editor')
require('./upgrade_required')
require('./modals/caption_create_edit_modal')
require('./modals/review_template_create_edit_modal')